import { render, staticRenderFns } from "./class.vue?vue&type=template&id=23752c35&scoped=true"
import script from "./class.vue?vue&type=script&lang=js"
export * from "./class.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23752c35",
  null
  
)

export default component.exports